export const QUESTIONNAIRE_LOGO_PRELOAD_ID = 'questionnaire-logo-preload';

/**
 * The org's questionnaire logo is the public lodgement page's LCP element (Sentry
 * `lcp.element`), but its URL is only known once `getPublicQuestionnaire` resolves and the
 * `<img>` only mounts after the org-settings and form-state render gates. Injecting a
 * preload as soon as the URL is known lets the browser fetch the image while those gates
 * are still resolving. Lives outside the route file so it stays unit-testable and out of
 * the route module's eager half.
 */
export function preloadQuestionnaireLogo(logoUrl: string | null | undefined): void {
    if (!logoUrl) {
        return;
    }
    // `link.href` reflects the resolved absolute URL, so resolve before comparing —
    // a raw relative path would otherwise never match and rewrite the href each visit.
    const resolvedHref = new URL(logoUrl, document.baseURI).href;
    const existing = document.getElementById(QUESTIONNAIRE_LOGO_PRELOAD_ID);
    if (existing instanceof HTMLLinkElement) {
        if (existing.href !== resolvedHref) {
            existing.href = resolvedHref;
        }
        return;
    }
    const link = document.createElement('link');
    link.id = QUESTIONNAIRE_LOGO_PRELOAD_ID;
    link.rel = 'preload';
    link.as = 'image';
    link.href = logoUrl;
    link.setAttribute('fetchpriority', 'high');
    document.head.appendChild(link);
}
